'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var typography_index = require('../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var TextSeparator = styled__default['default'].div.withConfig({ displayName: "ww-uikit_TextSeparator_locmlssh", componentId: "sc-g42r0v" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    margin: 16px 0;\n    align-items: center;\n    ", "\n    &::before,\n    &::after {\n        content: '';\n        background-color: ", ";\n        height: 1px;\n        flex: 1;\n        margin: 0 0 0 10px;\n    }\n    &::before {\n        margin: 0 10px 0 0;\n    }\n"], ["\n    display: flex;\n    justify-content: space-between;\n    margin: 16px 0;\n    align-items: center;\n    ", "\n    &::before,\n    &::after {\n        content: '';\n        background-color: ", ";\n        height: 1px;\n        flex: 1;\n        margin: 0 0 0 10px;\n    }\n    &::before {\n        margin: 0 10px 0 0;\n    }\n"])), typography_index.plainTextStyle, function (_a) {
    var theme = _a.theme;
    return theme.colors.borderCharcoal;
});
var SimpleSeparator = styled__default['default'].hr.withConfig({ displayName: "ww-uikit_SimpleSeparator_locmlssh", componentId: "sc-14ay1wg" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    height: 1px;\n    border-width: 0px;\n    margin: 16px 0;\n"], ["\n    background-color: ", ";\n    height: 1px;\n    border-width: 0px;\n    margin: 16px 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.borderCharcoal;
});
var templateObject_1, templateObject_2;

var Separator = function (_a) {
    var children = _a.children, props = tslib_es6.__rest(_a, ["children"]);
    return children ? React__default['default'].createElement(TextSeparator, tslib_es6.__assign({}, props),
        " ",
        children,
        " ") : React__default['default'].createElement(SimpleSeparator, null);
};

exports.default = Separator;
//# sourceMappingURL=index.js.map
